<template>
  <div
    class="is-flex is-align-items-center is-size-4 has-gap-4"
    :data-e2e="AICypressAttribute.views.CLARA_FOR_PLANNERS_CONTEXT_HEADER"
  >
    <IconView
      pack="cls"
      size="is-small"
      custom-class="cls-information-circle"
      class="has-text-grey"
    />
    <span class="has-text-weight-semibold has-text-grey">
      {{ $t('ai.clara-for-planners.answer-based-on') }}
    </span>
    <span class="has-text-weight-semibold has-text-primary">{{ contextLabel }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';

export default defineComponent({
  name: 'ClaraForPlannersContextHeader',
  components: {
    IconView
  },
  props: {
    jurisdiction: {
      type: String as PropType<string | null>,
      default: null
    },
    plan: {
      type: String as PropType<string | null>,
      default: null
    }
  },
  static: {
    AICypressAttribute
  },
  computed: {
    contextLabel(): string {
      return (
        [this.jurisdiction, this.plan].filter(Boolean).join(' · ') ||
        this.$t('ai.clara-for-planners.default-context')
      );
    }
  }
});
</script>
